import { UserResponse } from "./api/userSetController3311";
import { PermissionKeys, TSupplyConfig } from "./types";
import { ShopData } from "./utils/storage";
import type { Settings as LayoutSettings } from "@ant-design/pro-components";

/**
 * @see https://umijs.org/zh-CN/plugins/plugin-access
 * */
export default function access(initialState: {
  settings?: Partial<LayoutSettings>;
  currentUser?: UserResponse;
  loading?: boolean;
  fetchUserInfo?: () => Promise<UserResponse | undefined>;
  currentShop?: ShopData;
  permissionKeys?: PermissionKeys;
  supplyConfig?: TSupplyConfig;
}): Partial<PermissionKeys> & { hasAccess: boolean; noAccess: boolean } {
  // const { hasRoutes = [] } = initialState;
  return {
    hasAccess: true,
    noAccess: false,
    ...(initialState?.permissionKeys ?? {}),
    // 4.64.0 是否开启一条订单流
    EnableUnifiedOrder: !!initialState?.supplyConfig?.enable_unified_order,
    FrontWarehouse_Plan_InvitationPool: !initialState?.supplyConfig
      ?.enable_unified_order
      ? initialState?.permissionKeys?.FrontWarehouse_Plan_InvitationPool
      : false,
    // 发货单：需要同时满足权限和白名单
    Order_ShippingOrder:
      !!initialState?.permissionKeys?.Order_ShippingOrder &&
      !!initialState?.supplyConfig?.show_supply_direct_shipment_white_list,
  };
}
